export const CONTAINERIZATION_SUCCESS = 'Successfully Containerized!';
export const MOVE_SUCCESS = 'Successfully Moved!';
export const CONTAINERS = 'Containers';
export const CLOSE_CONTAINER_SUCCESS = 'Container successfully closed!'
export const RECEIVE_CONTAINER_SUCCESS = 'Container successfully received!'
export const PRINT_SUCCESS = 'Label sent to Printer: '
export const WIRELESS_PRINT_SUCCESS = 'Label printed successfully via wireless printer: ';
export const PROCESS_CONTAINER_SUCCESS = 'Container sent for processing successfully!';